/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Agent_LinkInputs */

const en_mk_tb_agent_link = /** @type {(inputs: Mk_Tb_Agent_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore agent teams`)
};

const id_mk_tb_agent_link = /** @type {(inputs: Mk_Tb_Agent_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat tim agent`)
};

/**
* | output |
* | --- |
* | "Explore agent teams" |
*
* @param {Mk_Tb_Agent_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_agent_link = /** @type {((inputs?: Mk_Tb_Agent_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Agent_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_agent_link(inputs)
	return en_mk_tb_agent_link(inputs)
});